import { Observable } from 'rxjs';
import { ImportExportGateway, IGetGateway, ISaveGateway } from '../gateways';
import {
  DEFAULT_TEXTS,
  ETextType,
  INormalText,
  NORMAL_TEXTS_SCHEMA,
} from '@web/dtos';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';

export class TextGateway
  extends ImportExportGateway<INormalText[], FormData, ETextType>
  implements
    IGetGateway<ETextType, IApiResponse<INormalText[]>>,
    ISaveGateway<INormalText[], IApiResponse<INormalText[]>>
{
  private readonly restCallBuilder: RestCallBuilder<
    INormalText[],
    INormalText[],
    string
  > = new RestCallBuilder<INormalText[], INormalText[], string>(DEFAULT_TEXTS);

  get(
    textType: ETextType = ETextType.Web
  ): Observable<IApiResponse<INormalText[]>> {
    return this.restCallBuilder
      .get('/normalTexts?textType=' + textType)
      .validate(API_RESPONSE_SCHEMA(NORMAL_TEXTS_SCHEMA), 'NormalText.get')
      .handleMessages()
      .build();
  }

  save(query: INormalText[]): Observable<IApiResponse<INormalText[]>> {
    return this.restCallBuilder
      .post('/normalTexts/', query)
      .validate(API_RESPONSE_SCHEMA(NORMAL_TEXTS_SCHEMA), 'NormalText.save')
      .handleMessages()
      .build();
  }

  download(textType: ETextType): Observable<IApiResponse<string>> {
    return this.restCallBuilder
      .getDownloadableContent('/normalTexts/download?textType=' + textType)
      .handleMessagesDownloadContent()
      .buildDownloadContent();
  }

  upload(query: FormData): Observable<IApiResponse<INormalText[]>> {
    return this.restCallBuilder
      .upload('/normalTexts/upload/', query)
      .handleMessages()
      .build();
  }
}
